<template>
    <el-dialog v-bind="$attrs" :modal="false" :before-close="handleBeforeClose" class="preview" title="预览" v-on="$listeners">
        <div class="bg-img">
            <video ref="video" v-if="isVideo(selection)" :src="selection.url" :alt="selection.name" class="video" controls></video>
            <img v-else :src="selection.url" :alt="selection.name" class="mosaic-bg"/>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button v-if="isEdit" type="primary" @click="handleToEdit">剪 切</el-button>
            <el-button @click="close">取 消</el-button>
        </div>
        <ul v-if="list.length" class="thumbnail-list">
            <li v-for="item in list" :key="item.url" class="thumbnail" @click="handleSwitch(item)">
                <video v-if="isVideo(item)" class="mosaic-bg" :src="item.url" :alt="item.name"></video>
                <img v-else class="mosaic-bg" :src="item.url" :alt="item.name"/>
            </li>
        </ul>
    </el-dialog>
</template>

<script>
export default {
    name: 'preview',
    props: {
        data: {
            type: Object,
            required: true
        },
        list: {
            type: Array,
            default: () => []
        },
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selection: {}
        }
    },
    watch: {
        data(val) {
            this.selection = val
        }
    },
    methods: {
        handleBeforeClose(done) {
            this.stopVideo()
            done()
        },
        handleToEdit() {
            this.$emit('edit', this.selection)
            this.close()
        },
        handleClose() {
            this.close()
        },
        handleSwitch(item) {
            this.selection = item
            this.stopVideo()
        },
        stopVideo() {
            if (this.isVideo(this.selection)) {
                this.$refs.video.pause()
            }
        },
        isVideo(file) {
            if (file.info && file.info.type) {
                return file.info.type.includes('video')
            } else if(file.raw && file.raw.type) {
                return file.raw.type.includes('video')
            } else if(file.url) {
                return file.url.includes('.mp4')
            }
            return false
        },
        close() {
            this.$emit('update:visible', false)
            this.stopVideo()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';

.preview {
    .bg-img {
        width: 100%;
        height: 500px;
        margin-bottom: 10px;

        img,
        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .video {
            background-color: #000;
        }
    }

    .thumbnail-list {
        display: flex;
        margin: 0;
        width: 100%;
        overflow-y: hidden;
        overflow-x: auto;
        list-style: none;
        box-sizing: border-box;

        .thumbnail {
            flex-shrink: 0;
            width: 80px;
            height: 80px;
            border: 1px solid #eee;
            cursor: pointer;

            img,
            video {
                width: 100%;
                height: 100%;
                object-fit: fill;
            }

            & + .thumbnail {
                margin-left: 10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/QnUpload-1.vue?89cb1208